import { render, staticRenderFns } from "./JerseyButton.vue?vue&type=template&id=006a2d4c&scoped=true&"
import script from "./JerseyButton.vue?vue&type=script&lang=ts&"
export * from "./JerseyButton.vue?vue&type=script&lang=ts&"
import style0 from "./JerseyButton.vue?vue&type=style&index=0&id=006a2d4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006a2d4c",
  null
  
)

export default component.exports